import ReactHTMLTableToExcel from "react-html-table-to-excel";

const thCls = "px-4 py-2 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap border-b border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 text-gray-600 dark:text-gray-300";
const tdCls = "px-4 py-2 text-xs border-b border-gray-100 dark:border-gray-700 align-middle";

export function AccumulativeDispatchList({ orders }) {
    const total = orders.reduce((sum, o) => sum + o.subtotal, 0);

    if (!orders || orders.length === 0) {
        return (
            <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm">
                <div className="py-16 text-center">
                    <div className="inline-flex items-center justify-center h-14 w-14 rounded-full bg-gray-100 dark:bg-gray-700 mb-4">
                        <i className="fas fa-chart-bar text-gray-400 dark:text-gray-500 text-2xl"></i>
                    </div>
                    <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Sin resultados</p>
                    <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">
                        Seleccione una ruta y aplique el filtro para ver las ventas acumuladas.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm overflow-hidden">

            {/* Card header */}
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-5 py-4 border-b border-gray-200 dark:border-gray-700">
                <div>
                    <h2 className="text-base font-semibold text-gray-900 dark:text-white flex items-center gap-2">
                        <i className="fas fa-chart-bar text-blue-500"></i>
                        Ventas acumuladas
                    </h2>
                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                        {orders.length} productos
                    </p>
                </div>
                <ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="inline-flex items-center gap-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white text-xs font-medium px-3 py-1.5 transition-colors focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
                    table="table-to-xls"
                    filename="report_of_sales"
                    sheet="report"
                    buttonText="↓ Exportar XLS"
                />
            </div>

            {/* Table */}
            <div className="overflow-x-auto bg-white dark:bg-gray-900">
                <table className="min-w-full text-sm border-separate border-spacing-0" id="table-to-xls">
                    <thead className="sticky top-0 z-10">
                        <tr>
                            <th className={`${thCls} text-center`} style={{ width: "8%" }}>#</th>
                            <th className={`${thCls} text-left`}>Producto</th>
                            <th className={`${thCls} bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300`} style={{ width: "12%" }}>
                                Stock Vendido
                            </th>
                            <th className={`${thCls} bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300`} style={{ width: "12%" }}>
                                Precio
                            </th>
                            <th className={`${thCls} bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300`} style={{ width: "14%" }}>
                                Subtotal
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map((o, index) => (
                            <tr key={index} className="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors">
                                <td className={`${tdCls} text-center`}>
                                    <span className="inline-block rounded-md bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 text-xs font-bold px-2 py-0.5">
                                        {o.productCode}
                                    </span>
                                </td>
                                <td className={`${tdCls} font-medium text-gray-800 dark:text-gray-200`}>
                                    {o.productName}
                                </td>
                                <td className={`${tdCls} text-center font-bold text-blue-700 dark:text-blue-300 bg-blue-50 dark:bg-blue-900/10`}>
                                    {o.quantitySold}
                                </td>
                                <td className={`${tdCls} text-right font-semibold text-emerald-700 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-900/10`}>
                                    S/ {Number(o.salePrice).toFixed(2)}
                                </td>
                                <td className={`${tdCls} text-right font-semibold text-amber-700 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/10`}>
                                    S/ {Number(o.subtotal).toFixed(2)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr className="bg-gray-800 dark:bg-gray-950">
                            <td
                                colSpan={4}
                                className="px-4 py-2 text-xs font-bold text-right text-white uppercase tracking-wide border-t border-gray-600"
                            >
                                <i className="fas fa-calculator mr-2"></i>TOTAL
                            </td>
                            <td className="px-4 py-2 text-xs text-right font-bold text-amber-300 whitespace-nowrap border-t border-gray-600">
                                S/ {Number(total).toFixed(2)}
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
}
